import Collection from 'lib/Collection';
import Pond from 'model/Pond';
import config from 'config';

export default Collection.extend({
	model: Pond,

	// Chargement des données depuis l'API ou depuis un fichier local
	url: config.url.pond,
	file: config.file.pond,

	comparator: function( pond )
	{
		return -pond.get('created_at');
	},

	toString: function() {
		return 'liste des mares';
	},	
});
